import { Clipboard } from 'lucide-react';

export default function EmailForm({ value, onChange, onPaste }) {
  return (
    <div>
      <label className="block text-sm font-medium text-text-primary mb-2">Collez le message suspect ici</label>
      <div className="relative">
        <textarea
          className="input-field min-h-[220px] resize-none pb-16"
          placeholder="Collez ici le message que vous avez reçu : email, SMS, WhatsApp, Messenger… tout le texte que vous voyez."
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        <button
          type="button"
          onClick={onPaste}
          className="absolute bottom-4 left-1/2 -translate-x-1/2 min-h-11 px-4 rounded-xl bg-accent-blue/10 text-accent-blue flex items-center gap-2 font-medium active:scale-95 transition-transform"
        >
          <Clipboard className="w-5 h-5" />
          Coller depuis le presse-papier
        </button>
      </div>
    </div>
  );
}
